import PropTypes from 'prop-types';

import { ChevronDownIcon } from 'lucide-react';
import { Separator, DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, Button } from 'twyne-new.ui';

import { ActiveForm } from '@/components/form/ActiveSwitch';
import HeaderContainerForm from '@/components/headerContainer/Form';
import { formatDateTime } from '@/utils';
import history from '@/utils/history';
import PageVariablesModal from 'components/modals/PageVariablesModal';

const modalTop = () => <div>
  <p>Leave Matching PID field blank to show pixel on all requests. Other criteria, such as slot position, will still apply.</p>
  <p>Pixels of type HTTP POST will send data of media type application/x-www-form-urlencoded. Data entered as POST Data must be a JSON blob of key: value, where key is the form field name and value is the data to send.</p>
  <p></p>
</div>

function PixelHeading({ data, active, onChangeActive }) {
  return <>
    <HeaderContainerForm
      title='Pixels'
      data={{ ...data, createdAt: formatDateTime(data?.created_at), updatedAt: formatDateTime(data?.updated_at) }}
      onCancel={() => history.goBack()}
      className='relative'
    >
      <ActiveForm active={active} onChangeActive={onChangeActive} />
      <Separator orientation='vertical' className='py-4' />
      <DropdownMenu optionsLabel='Options'>
        <DropdownMenuTrigger className='flex items-center gap-1'>
          <Button size='lg' variant='outline'>
            Quick Actions
            <ChevronDownIcon size={16} />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align='start' forceMount>
          <PageVariablesModal top={modalTop()} />
        </DropdownMenuContent>
      </DropdownMenu>
    </HeaderContainerForm>
  </>
}

export default PixelHeading

PixelHeading.propTypes = {
  data: PropTypes.any,
};
